// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_dock_management_styles" + "." + "ef05fbc3" + ".chunk.css";
};